
import { SettingScreenNavigationProps } from "./types"
import React from "react"
import Setting from "./setting-screen"
import { PageRoot } from "~screens/page-root"


const SettingScreen: React.FC<SettingScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <Setting route={route}/>
    </PageRoot>
  )
}

export default SettingScreen
